import { memo } from 'react';

import { IImageMedia, ILink } from '~/lib/data-contract';
import Link from '~/shared/components/Link/Link';
import { ResponsiveImageMedia } from '~/shared/components/ResponsiveImageMedia/ResponsiveImageMedia';

import styles from './productDetailsStamp.module.css';

export const imageSizes = '96px';

export type ProductDetailsStampProps = {
	stamp: IImageMedia;
	link?: ILink;
};

export const ProductDetailsStamp = memo<ProductDetailsStampProps>(({ stamp, link }) => {
	if (link) {
		return (
			<Link
				href={link.url}
				target={link.target}
				title={link.title}
				isCustomStyle
				aria-label={`${link.url} stamp`}
			>
				<div className={styles.root}>
					<ResponsiveImageMedia
						image={stamp}
						sizes={imageSizes}
					/>
				</div>
			</Link>
		);
	}

	return (
		<div className={styles.root}>
			<ResponsiveImageMedia
				image={stamp}
				sizes={''}
			/>
		</div>
	);
});
